// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1HZ5k","infoBtn":"quickbooks_infoBtn__3nyJD","formBox":"quickbooks_formBox__2iYuM","formFooter":"quickbooks_formFooter__3ah9_"};